import axios from 'axios';

/**
 * Axios instance for Global Orders API
 * Uses X-API-Key header for authentication instead of JWT
 */
const GlobalApiAxios = () => {
  const defaultOptions = {
    baseURL: process.env.REACT_APP_GLOBAL_API_BASE_URL || process.env.REACT_APP_BACKEND_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      'X-API-Key': process.env.REACT_APP_GLOBAL_API_KEY || '',
    },
  };

  // Create instance
  const instance = axios.create(defaultOptions);

  // Request interceptor - Add API key to all requests
  instance.interceptors.request.use(
    (config) => {
      const apiKey = process.env.REACT_APP_GLOBAL_API_KEY;
      if (apiKey) {
        config.headers['X-API-Key'] = apiKey;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Response interceptor - Handle errors
  instance.interceptors.response.use(
    (res) => res,
    async (err) => {
      // Handle 401 Unauthorized (invalid API key)
      if (err.response?.status === 401) {
        console.error('Global API: Invalid or missing API key');
      }
      // Handle 404 Not Found
      if (err.response?.status === 404) {
        console.error('Global API: Resource not found');
      }
      // Handle 400 Bad Request
      if (err.response?.status === 400) {
        console.error('Global API: Bad request', err.response.data);
      }
      return Promise.reject(err);
    }
  );

  return instance;
};

export default GlobalApiAxios();


